/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
/**
 * getRegExp
 * 获取正则表达式
 *
 * @param type {string}
 * @returns {string}
 */
export function getRegExp(type) {
  switch (type) {
    case 'mobile':
      return /^1\d{10}$/g

    case 'mobile-code':
      return /^\d{6}$/g

    case 'telephone':
      return /(^\d{3}-\d{8}$)|(^\d{4}-\d{7}$)/g

    case 'credit-code':
      return /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g

    case 'id':
      return /(^\d{15}$)|(^\d{17}[xX0-9]$)/g

    case 'email':
      return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g
    case 'email2':
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    case 'specialPhone':
      return /^1([34589][0-9]{9}|6[012345689]{1}[0-9]{8}|(7[2-9]{1})[0-9]{8})/
    case 'specialID':
      return /(^\d{15}$)|(^\d{17}[xX0-9]$)/g
    case 'passport':
      return /^([a-zA-z]|[0-9]){5,17}$/

    default:
      return ''
  }
}

export function getTypeName(type) {
  switch (type) {
    case 'mobile':
      return '手机号码'

    case 'mobile-code':
      return '手机验证码'

    case 'phone':
      return '联系电话'

    case 'telephone':
      return '固定电话'

    case 'credit-code':
      return '统一社会信用代码'

    case 'id':
      return '身份证号'

    case 'email':
      return '电子邮箱'

    case 'specialPhone': // 限制170、171的无需实名虚拟号
      return '手机号码'

    case 'specialID':
      return '身份证或统一社会信用代码'
    case 'passport':
      return '护照'

    default:
      return ''
  }
}
export function validateField(type) {
  if (type === 'phone') {
    // eslint-disable-next-line consistent-return
    return (rule, value, callback) => {
      // 既不是固话，也不是手机
      if (!getRegExp('mobile').test(value.trim()) && !getRegExp('telephone').test(value.trim())) {
        return callback(new Error(`${getTypeName(type)}格式不正确！`))
      }

      callback()
    }
  }
  if (type === 'specialPhone') {
    // eslint-disable-next-line consistent-return
    return (rule, value, callback) => {
      // 限制170、171的无需实名虚拟号
      if (!getRegExp('specialPhone').test(value.trim())) {
        return callback(new Error('该手机号段不符合申请要求，请重新输入!'))
      }

      callback()
    }
  }
  if (type === 'specialID') {
    // eslint-disable-next-line consistent-return
    return (rule, value, callback) => {
      if (!getRegExp('specialID').test(value.trim())) {
        return callback(new Error(`请输入正确的${getTypeName(type)}！`))
      }

      callback()
    }
  }
  // eslint-disable-next-line consistent-return
  return (rule, value, callback) => {
    if (!getRegExp(type).test(value.trim())) {
      return callback(new Error(`${getTypeName(type)}格式不正确！`))
    }

    callback()
  }
}
